import Page from "@jumbo/shared/Page";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { lazy } from "react";
import { LoadablePage } from "app/utils/loadablePage";

const ListApprovalConfig = lazy(() => import("app/pages/ApprovalConfigMaster/ListApprovalConfig"));


export const approvalConfigMasterRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "approval_config", "view"],
      },
    ],
    routes: [
      {
        path: "/master/approval-config",
        element: (
          LoadablePage(ListApprovalConfig)
        ),
      },
    ],
  },
];